/**
 *
 * @param {number} targetY
 * @param {number} time 单位ms
 */
export const scrollTo = (targetY, time = 160) => {
  const initY = document.documentElement.scrollTop || document.body.scrollTop

  const _needScrollY = targetY - initY
  let step = time / 16
  const stepY = _needScrollY / step
  let timer

  const scrollFn = () => {
    const currentY =
      document.documentElement.scrollTop || document.body.scrollTop
    if (step > 0 && step - 1 >= 0) {
      window.scrollTo({
        top: currentY + stepY
      })
      step--
      timer = setTimeout(() => {
        scrollFn()
      }, 16)
    } else {
      window.scrollTo({
        top: targetY
      })
      clearTimeout(timer)
    }
  }
  scrollFn()
}

export const getOffsetTop = ele => {
  let tmp = ele.offsetTop
  let node = ele.offsetParent
  while (node != null) {
    tmp += node.offsetTop
    node = node.offsetParent
  }
  return tmp
}
